import React from "react";
import styled, { keyframes, useTheme } from "styled-components";
import { transparent } from "../../colors";
var innerCircleSizes = {
  small: "24px",
  medium: "32px",
  large: "72px"
};
var spin = keyframes(["to{transform:rotate(360deg);}"]);
var transitionTime = "0.75s";
/** This Spinner is not exported for use by consumers, only used internally in GDS.
 * For a full-featured documented spinner, please use the LoadingSpinner component.
 */
export var Spinner = function Spinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "small" : _ref$size,
    _ref$colorVariant = _ref.colorVariant,
    colorVariant = _ref$colorVariant === void 0 ? "primary" : _ref$colorVariant;
  var theme = useTheme();
  var colors = {
    primary: theme._links.primary.color,
    // should update w co-branding
    secondary: theme.text.primary,
    inverse: theme.text.inverse
  };
  var spinnerColor = colors[colorVariant];
  return /*#__PURE__*/React.createElement(AnimatedSpinner, {
    $size: size,
    $spinnerColor: spinnerColor
  });
};
var AnimatedSpinner = styled.span.withConfig({
  displayName: "Spinner__AnimatedSpinner",
  componentId: "sc-337kba-0"
})(["position:relative;display:flex;align-items:center;justify-content:center;width:", ";height:", ";color:", ";&::before{position:absolute;display:block;width:100%;height:100%;border-color:", ";border-style:solid;border-width:calc(", " / 10);border-left-color:", ";border-radius:50%;animation:", " ", " linear infinite !important;content:\"\";}"], function (props) {
  return innerCircleSizes[props.$size];
}, function (props) {
  return innerCircleSizes[props.$size];
}, function (props) {
  return props.$spinnerColor;
}, function (props) {
  return props.$spinnerColor;
}, function (props) {
  return innerCircleSizes[props.$size];
}, function (props) {
  return transparent(props.$spinnerColor);
}, spin, transitionTime);